var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yd-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        width: "1250px",
        "append-to-body": "",
      },
      on: { close: _vm.beforeClose },
    },
    [
      _c("div", { staticClass: "contain" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "el-form",
              {
                ref: "bannerForm",
                attrs: {
                  model: _vm.form,
                  rules: _vm.rules,
                  "label-width": "120px",
                  size: "small",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "名称", prop: "name" } },
                  [
                    _c("el-input", {
                      directives: [{ name: "no-emoji", rawName: "v-no-emoji" }],
                      staticStyle: { width: "400px" },
                      attrs: {
                        placeholder: "请输入广告名称",
                        maxlength: "30",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "name", $$v)
                        },
                        expression: "form.name",
                      },
                    }),
                  ],
                  1
                ),
                _c("el-form-item", { attrs: { label: "权重", prop: "sort" } }, [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("el-input-number", {
                        attrs: { min: 1, max: 10 },
                        model: {
                          value: _vm.form.sort,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "sort", $$v)
                          },
                          expression: "form.sort",
                        },
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "form-tip",
                          staticStyle: { width: "450px" },
                        },
                        [_vm._v("（权重数值越小越靠前，banner优先级越高）")]
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: "所属广告组", prop: "adGroupId" } },
                  [
                    _c("AdGroupSelect", {
                      attrs: {
                        multiple: false,
                        required: "",
                        label: false,
                        disabled: !!(
                          _vm.adGroupId &&
                          _vm.templateId &&
                          _vm.displayPageName
                        ),
                      },
                      on: { select: _vm.adGroupChange },
                      model: {
                        value: _vm.form.adGroupId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "adGroupId", $$v)
                        },
                        expression: "form.adGroupId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "展示页面", prop: "displayPage" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "300px" },
                        attrs: {
                          placeholder: "请选择",
                          clearable: "",
                          disabled: true,
                        },
                        model: {
                          value: _vm.form.displayPage,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "displayPage", $$v)
                          },
                          expression: "form.displayPage",
                        },
                      },
                      _vm._l(_vm.pageEnumList, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "展示时间",
                      required: "",
                      prop: "startTime",
                    },
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "400px" },
                      attrs: {
                        type: "datetimerange",
                        "range-separator": "至",
                        "start-placeholder": "选择开始日期",
                        "end-placeholder": "选择结束日期",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        "picker-options": _vm.pickerOptionStart(),
                        "default-time": ["00:00:00", "23:59:59"],
                      },
                      on: { change: _vm.handleDateRangeChange },
                      model: {
                        value: _vm.dateRange,
                        callback: function ($$v) {
                          _vm.dateRange = $$v
                        },
                        expression: "dateRange",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "展示地区",
                      prop: _vm.form.allArea === 1 ? "allArea" : "areaIdList",
                    },
                  },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.allArea,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "allArea", $$v)
                              },
                              expression: "form.allArea",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("全部地区"),
                            ]),
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v("部分地区"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.form.allArea !== 1
                      ? _c("YdCitySelect", {
                          attrs: {
                            mode: "2",
                            placeholder: "请选择地区",
                            customHttp: _vm.getDriverAreaTree,
                            fieldFormat: _vm.fieldFormat,
                          },
                          model: {
                            value: _vm.form.areaIdList,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "areaIdList", $$v)
                            },
                            expression: "form.areaIdList",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.form.templateId === 1
              ? _c("banner1", {
                  ref: "banner",
                  attrs: {
                    slotKeys: _vm.slotKeys,
                    useTabStyle: false,
                    isEdit: _vm.isEdit,
                  },
                  model: {
                    value: _vm.form,
                    callback: function ($$v) {
                      _vm.form = $$v
                    },
                    expression: "form",
                  },
                })
              : _vm._e(),
            _vm.form.templateId === 2
              ? _c("banner2", {
                  ref: "banner",
                  attrs: {
                    slotKeys: _vm.slotKeys,
                    useTabStyle: false,
                    isEdit: _vm.isEdit,
                  },
                  model: {
                    value: _vm.form,
                    callback: function ($$v) {
                      _vm.form = $$v
                    },
                    expression: "form",
                  },
                })
              : _vm._e(),
            _vm.form.templateId === 3
              ? _c("banner3", {
                  ref: "banner",
                  attrs: {
                    slotKeys: _vm.slotKeys,
                    useTabStyle: false,
                    isEdit: _vm.isEdit,
                  },
                  model: {
                    value: _vm.form,
                    callback: function ($$v) {
                      _vm.form = $$v
                    },
                    expression: "form",
                  },
                })
              : _vm._e(),
            _vm.form.templateId === 4
              ? _c("banner4", {
                  ref: "banner",
                  attrs: {
                    slotKeys: _vm.slotKeys,
                    useTabStyle: false,
                    isEdit: _vm.isEdit,
                  },
                  model: {
                    value: _vm.form,
                    callback: function ($$v) {
                      _vm.form = $$v
                    },
                    expression: "form",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm.form.templateId
          ? _c(
              "div",
              { staticClass: "right" },
              [
                _c("banner-preview", {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "imgSlot",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "preview-img-container" },
                              [
                                _c("img", {
                                  staticClass: "preview-img",
                                  attrs: { src: _vm.img, alt: "Banner预览" },
                                }),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1727816758
                  ),
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.closeEdit } }, [_vm._v("取 消")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("保 存")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }